module.exports = __webpack_public_path__ + "img/planner-filter-sentosa.2cc6bd16.svg";